




































import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import CFormSelectOption from '~/components/shared/configurable/form/select/CFormSelectOption.vue'
import { Ref } from '@vue/composition-api'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  components: { FieldError, CCustomSelect, CFormSelectOption },
  props: formFieldProps,
  setup(props) {
    const { specs, humanName, name } = toRefs(props)

    const options = computed(() => specs.value?.values || [])
    const placeholder = computed(
      () => specs.value?.placeholder || humanName.value
    )
    const isMultiselect = computed(() => specs.value?.multiple)

    const multiValue = ref([])
    const singleValue = ref(null)
    function onValue(v: Ref<any>) {
      if (Array.isArray(v.value)) {
        multiValue.value = v.value
        singleValue.value = v.value.length > 0 ? v.value[0] : null
      } else {
        multiValue.value = v.value ? [v.value] : v.value
        singleValue.value = v.value
      }
    }
    function onSuggestions(s: Ref<any>) {
      if (!isMultiselect.value && !singleValue.value && s.value.length > 0) {
        singleValue.value = s.value[0]
        valueChanged(name.value, [s.value[0]])
      }
    }
    const {
      error,
      debouncedValueChanged,
      isValid,
      valueChanged,
      suggestions
    } = useClassifiedForm(props, { onValue, onSuggestions })

    const handleMultiValueChange = (values: any[]) => {
      debouncedValueChanged(name.value, values)
      error.value = null
    }

    const handleSingleValueChange = (value: any) => {
      valueChanged(name.value, [value])
      error.value = null
    }

    return {
      options,
      placeholder,
      isMultiselect,
      multiValue,
      singleValue,
      error,
      isValid,
      suggestions,
      handleMultiValueChange,
      handleSingleValueChange
    }
  }
})
